import * as React from "react";
function SvgDpitSelectArrowDown(props) {
  return <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...props}><path stroke="currentColor" strokeWidth={3} d="M11 18l12.843 12.808L36.718 18" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
export default __webpack_public_path__ + "main/assets/dpit-select_arrow-down-c1a3deda.svg";
export { SvgDpitSelectArrowDown as ReactComponent };